import { render, staticRenderFns } from "./product-details-attributes.vue?vue&type=template&id=6cd6d7fa&scoped=true&"
import script from "./product-details-attributes.vue?vue&type=script&lang=js&"
export * from "./product-details-attributes.vue?vue&type=script&lang=js&"
import style0 from "./product-details-attributes.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./product-details-attributes.vue?vue&type=style&index=1&id=6cd6d7fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6d7fa",
  null
  
)

export default component.exports